/** @type {import('../types').ProgramConfig} */
export default {
  code: 'RUBICON',
  displayName: 'Rubicon Initiative',
  shortName: 'RUBICON',
  color: 'orange',
  statusLabels: {
    recommend_approval: 'Recommend Approval',
    recommend_rejection: 'Recommend Rejection',
    needs_review: 'Needs Review',
  },
  sidebarItems: [],
  listColumns: [],

  feedback: {
    enabled: true,
    validations: [
      { key: 'partner_eligibility',
        label: '1. Partner Eligibility (sub-program routing)',
        keywords: ['partner eligibility', 'partner_eligibility'] },
      { key: 'opportunity_and_naming',
        label: '2. Opportunity and Naming (ACE stage, activity name convention)',
        keywords: ['opportunity and naming', 'opportunity_and_naming', 'ace stage', 'naming convention'] },
      { key: 'fund_request_date',
        label: '3. Fund Request Date (14-day submission window)',
        keywords: ['fund request date', 'fund_request_date'] },
      { key: 'duplication',
        label: '4. Duplication (Opportunity ID / AWS Opportunity ID)',
        keywords: ['duplication', 'duplicate'] },
      { key: 'funding_letter',
        label: '5. Funding Letter (PDF, signatures, document type)',
        keywords: ['funding letter', 'funding_letter'] },
      { key: 'direct_matches',
        label: '6. Direct Matches (partner, customer, opportunity ID)',
        keywords: ['direct matches', 'direct_matches'] },
      { key: 'key_fields_checks',
        label: '7. Key Fields (cash, ARR match vs letter, completion date, milestones)',
        keywords: ['key fields', 'key_fields_checks', 'amounts', 'arr'] },
    ],
    decisionOptions: [
      { value: 'recommend_approval',  label: 'Recommend Approval' },
      { value: 'recommend_rejection', label: 'Recommend Rejection' },
      { value: 'needs_review',        label: 'Needs Review' },
    ],
  },
};
